import { useContext, useEffect, useId, useMemo, useRef, useState } from 'react';
import inside from 'url:../../assets/taco/bongobg-inside.png';
import ExecProvider from '../../providers/ExecProvider';
import { BONGO, BONGODRESSED, DRESSUP, TACOG } from './TACOG';
import circus_tent from 'url:../../assets/taco/Circus Tent 8.png';
import logo from 'url:../../assets/taco/LOGO3.png';
import { useNavigate } from 'react-router';
import TACOProvider from './TACOProvider';
import taco from 'url:../../assets/taco/Taco 5.png';
import yoyo from "url:../../assets/cursors/YoYoCursor.png";
import PlayerProvider from '../../providers/PlayerProvider';
import { CRS_INFO_YYO } from '../../components/MagicCursor';
import CursorProvider, { CursorState } from '../../providers/CursorProvider';

export function TACOI () {
    const tacoProvider = useContext(TACOProvider.context);

    var comp = useMemo(() => {
        return <div className='v-box'>
            <IBLK />
            <div className="pos-fix v-box center-all no-events" style={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
            }}>
                <IINT />
                <IGAME />
                <IPRIZE />
                <IPILE />
                <OBONGO />
                <IBONGO />
            </div>
        </div>
    }, [tacoProvider.darkMode]);

    return comp;
}

function IBLK () {
    const tacoProvider = useContext(TACOProvider.context);
    return tacoProvider.darkMode 
        ? <div className="pos-fix bg-black opacity-90 v-box center-all yes-events" style={{
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        }} onClick={() => { 
            if (tacoProvider.diningIn)
                tacoProvider.exitShop(); 
            else if (tacoProvider.gameOn)
                tacoProvider.exitGame(false);
        }} />
        : <div/>;
}

function IINT () {
    const tacoProvider = useContext(TACOProvider.context);
    return tacoProvider.diningIn
            ? <>
                <img className='pos-abs' src={circus_tent} style={{width: 1500, top:64}} />
                <img className='pos-abs z-2' src={logo} style={{width: 512, top: 256}} />
                <img className='width-1024 taco-box z-1' src={inside} />
            </>
            : <div/>
}

function IGAME () {
    const tacoProvider = useContext(TACOProvider.context);
    return tacoProvider.gameOn ? <DRESSUP onClick={() => { 
        // ut(t + 1);
    }} /> : <div/>
}

function IPRIZE () {
    const tacoProvider = useContext(TACOProvider.context);
    return (tacoProvider.bongoStay && tacoProvider.diningIn) ? <PrizePile /> : <div/>;
}

function OBONGO () {
    const tacoProvider = useContext(TACOProvider.context);
    return (tacoProvider.bongoStay && !tacoProvider.diningIn)
        ? <div className='pos-abs z-2' style={{
            right: "18.5%",
            top: "37.5%"
        }}>
            <BONGO height={384} />
        </div>
        : <div/>
}

function IBONGO () {
    const tacoProvider = useContext(TACOProvider.context);
    return (tacoProvider.bongoStay && tacoProvider.diningIn)
        ? <div className='pos-abs z-2 bongo-enter' style={{
            right: "18.5%",
            top: "37.5%"
        }}>
            <BONGODRESSED />
        </div>
        : <div/>
}

function IPILE () {
    const tacoProvider = useContext(TACOProvider.context);
    const [eaten, setEaten] = useState<number>(0);

    let animationFrame : number = 0;
    let lastEatTime = Date.now() / 1000.0 + 1;
    const resetEatTime = () => { lastEatTime = Date.now() / 1000.0; };

    const autoUpdate = () => {
        const animate = tacoProvider.diningIn && tacoProvider.bongoStay;
        if (!animate)
            return;
        const currentTimeInSeconds = Date.now() / 1000.0;
        if (currentTimeInSeconds - lastEatTime > 1)
        {
            resetEatTime();
            setEaten(eaten + 1);
        }
    }

    const init = () => {
        loop();
    }

    const deinit = () => {
        cancelAnimationFrame(animationFrame);
    }

    const loop = () => {
        autoUpdate();
        animationFrame = requestAnimationFrame(loop);
    };

    useEffect(() => {
        init();
        return () => {
            deinit();
        }
    }, [tacoProvider, eaten]);

    if (!tacoProvider.diningIn)
        return <div />

    return <div className='pos-abs yes-events' key='bongo-food-pile'>
        { eaten < 21 ? <Food src={taco} x={80} y={64} /> : null }
        { eaten < 20 ? <Food src={taco} x={48} y={64} /> : null }
        { eaten < 19 ? <Food src={taco} x={16} y={64} /> : null }
        { eaten < 18 ? <Food src={taco} x={-16} y={64} /> : null }
        { eaten < 17 ? <Food src={taco} x={-48} y={64} /> : null }
        { eaten < 16 ? <Food src={taco} x={-80} y={64} /> : null }
        { eaten < 15 ? <Food src={taco} x={64} y={34} /> : null }
        { eaten < 14 ? <Food src={taco} x={32} y={34} /> : null }
        { eaten < 13 ? <Food src={taco} x={0} y={34} /> : null }
        { eaten < 12 ? <Food src={taco} x={-32} y={34} /> : null }
        { eaten < 11 ? <Food src={taco} x={-64} y={34} /> : null }
        { eaten < 10 ? <Food src={taco} x={48} y={4} /> : null }
        { eaten < 9 ? <Food src={taco} x={16} y={4} /> : null }
        { eaten < 8 ? <Food src={taco} x={-16} y={4} /> : null }
        { eaten < 7 ? <Food src={taco} x={-48} y={4} /> : null }
        { eaten < 6 ? <Food src={taco} x={32} y={-26} /> : null }
        { eaten < 5 ? <Food src={taco} x={0} y={-26} /> : null }
        { eaten < 4 ? <Food src={taco} x={-32} y={-26} /> : null }
        { eaten < 3 ? <Food src={taco} x={16} y={-56} /> : null }
        { eaten < 2 ? <Food src={taco} x={-16} y={-56} /> : null }
        { eaten < 1 ? <Food src={taco} x={0} y={-86} /> : null }
    </div>
}

function Food (props: {
    src: string,
    x: number,
    y: number
}) {
    return <img src={props.src} className='pos-abs width-64 z-4' style={{ 
        left: props.x, 
        top: props.y
    }}></img>
}

function PrizePile () {
    const player = useContext(PlayerProvider.context);
    const cursor = useContext(CursorProvider.context);
    const nav = useNavigate();

    return <div className='pos-abs yes-events'>
        <img src={yoyo} className='pos-abs width-32 z-3 cursor-pointer' style={{left: 16, top: 48}} onClick={() => {
            player.unlockCursor(CRS_INFO_YYO.key);
            cursor.setState(CursorState.YOY);
        }} />
    </div>
}
